import { defineMessages } from 'react-intl';

const scope = 'app.containers.TipDirectPages.GuestFeedback';

export default defineMessages({
  title: { id: `${scope}.title`, defaultMessage: 'Guest feedback' },
  loading: { id: `${scope}.loading`, defaultMessage: 'Loading your feedback form' },
  loadFailed: {
    id: `${scope}.loadFailed`,
    defaultMessage: 'We couldn’t load your feedback form. Check your connection and try again.'
  },
  retry: { id: `${scope}.retry`, defaultMessage: 'Try again' },

  noToursTitle: { id: `${scope}.noToursTitle`, defaultMessage: 'No feedback form yet' },
  noToursBody: {
    id: `${scope}.noToursBody`,
    defaultMessage:
      'None of your tours has a guest feedback form. Ask your office to set one up for your tour.'
  },

  pickTitle: { id: `${scope}.pickTitle`, defaultMessage: 'Which departure is this?' },
  pickBody: {
    id: `${scope}.pickBody`,
    defaultMessage:
      'Guests answer for this tour and departure, so head office can see how each one went.'
  },
  tourLabel: { id: `${scope}.tourLabel`, defaultMessage: 'Tour' },
  tourPlaceholder: { id: `${scope}.tourPlaceholder`, defaultMessage: 'Choose a tour' },
  dateLabel: { id: `${scope}.dateLabel`, defaultMessage: 'Departure date' },
  dateHint: {
    id: `${scope}.dateHint`,
    defaultMessage: 'The day this group’s tour started.'
  },
  showQr: { id: `${scope}.showQr`, defaultMessage: 'Show QR code' },
  cancel: { id: `${scope}.cancel`, defaultMessage: 'Cancel' },

  qrTitle: { id: `${scope}.qrTitle`, defaultMessage: 'Show this to your guests' },
  qrBody: {
    id: `${scope}.qrBody`,
    defaultMessage:
      'Each guest scans it with their phone camera and fills in the form on their own phone. It takes about 3 minutes.'
  },
  departed: { id: `${scope}.departed`, defaultMessage: 'Departed {date}' },
  recentNone: {
    id: `${scope}.recentNone`,
    defaultMessage: 'No responses in the last {hours} hours yet'
  },
  recentCount: {
    id: `${scope}.recentCount`,
    defaultMessage:
      '{count, plural, one {# response} other {# responses}} in the last {hours} hours'
  },
  recentPrivacy: {
    id: `${scope}.recentPrivacy`,
    defaultMessage: 'Answers go straight to head office.'
  },
  changeDeparture: { id: `${scope}.changeDeparture`, defaultMessage: 'Change tour or date' },
  openFailed: {
    id: `${scope}.openFailed`,
    defaultMessage: 'That didn’t work. Check the tour and date and try again.'
  }
});
